import Fingerprint2 from 'fingerprintjs2'
import $cookies from 'js-cookie'
// 设置全局

function setBfp() { // 浏览器指纹码
  Fingerprint2.get((components) => { // 浏览器指纹码
    const values = components.map(function(component, index) {
      if (index === 0) { // 把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
        return component.value.replace(/\bNetType\/\w+\b/, '')
      }
      return component.value
    })
    // 生成最终id murmur
    const murmur = Fingerprint2.x64hash128(values.join(''), 31)
    const now = new Date(new Date(new Date().getTime()).setFullYear(9998, 0, 0))
    $cookies.set('wiki-bfp', murmur, { expires: now, path: '/' })
    localStorage.setItem('wiki-bfp', murmur, { expires: now, path: '/' })
  })
}


function init() {
  
  setBfp()
  // getIp()
  // setcountryInfo()
}
init() // 执行

